import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MOBILE_API_BASE_URL } from '../../config.js'
import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
  statisticsAction,
  statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const AttendanceLogList = (props) => {
  const sparkline1 = React.createRef();
  const sparkline2 = React.createRef();
  const sparkline3 = React.createRef();
  const sparkline4 = React.createRef();


  const handleStatistics = (e) => {
    statisticsAction(e)
  }
  const closeStatistics = (e) => {
    statisticsCloseAction(e)
  }

  const { fixNavbar, statisticsOpen, statisticsClose } = props;


  const today = new Date().toISOString().split("T")[0];


  const [user, setUser] = useState({
    start_date: today,
    end_date: today,
    employeedet: "ALL"
  })






  const history = useHistory();
  const [data, setData] = useState([]);
  const [dataval, setdataval] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [urlres, setUrlRes] = useState(false);
  const [style1, setStyle1] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const { sortConfig, sortData, handleSort } = useSortData();


  const handelInput = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    console.log(name, value)
    setUser({ ...user, [name]: value });

    if (event.target.value === '1') {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }




  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  let filteredItems = records.filter((item) =>
    `${item.emp_id.toLowerCase()}${item.emp_name.toLowerCase()}${item.department_name.toLowerCase()}${item.punch_direction.toLowerCase()}${item.log_date.toLowerCase()}${item.log_date_time.toLowerCase()}`.includes(searchTerm.toLowerCase())

  );
  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  // const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  const sortedItems = sortData(filteredItems);
  const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearch = (event) => {
    //console.log(event.target.value);
    setSearchTerm(event.target.value);
  };


  const clearInput = () => {
    setSearchTerm("");
  };

  //   const handleRowsPerPageChange = (e) => {
  // 	setItemsPerPage(Number(e.target.value));
  // 	setCurrentPage(1); // Reset to first page
  //   };


  useEffect(() => {
    axios.get(API_BASE_URL + '/showallemployee', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })

      // .then(res =>console.log(res.data.user_det))
      .then(res => setData(res.data.user_det))
      .catch(err => console.log(err));
  }, [])






  const handleSubmit = async (e) => {
    e.preventDefault();

    // alert(user.start_date);
    // alert(user.end_date);

    // alert(user.employeedet);
    setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL + '/log_list',
        { start_date: user.start_date, end_date: user.end_date, user_id: user.employeedet },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }

      );
      //  console.log(response.data.shiftinfo);
      setRecords(response.data.attendancelog); // Assuming the API response contains the records in `response.data`
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const options = [
    { value: "ALL", label: "All Employee" },
    ...data.map(option => ({
      value: option.user_id,
      label: `${option.first_name} ${option.last_name} ${option.employee_id}`
    }))
  ];



  const columns = [
    { label: "Emp Id", key: "emp_id", sortable: true },
    { label: "Image", key: "image" },
    { label: "Employee Name", key: "emp_name", sortable: true },
    { label: "Department", key: "department_name", sortable: true },
    { label: "Address", key: "address", sortable: true },
    { label: "Log Date", key: "log_date", sortable: true },
    { label: "Log Time", key: "log_date_time", sortable: true },
    { label: "Punch Direction", key: "punch_direction", sortable: true }
  ];




  return (
    <>
      <style>{`
        .ng: 5px;
    
    transition: transform .2s;
    width: 50px;
    height: 50px;
    margin: 0 auto;
  }
  
  .zoom:hover {
    -ms-transform: scale(3.5); /* IE 9 */
    -webkit-transform: scale(3.5); /* Safari 3-8 */
    transform: scale(3.5); 
  }
      `}</style>


      <div>
        <div>
          <div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
            <div className="container-fluid">

              <ToastContainer />

            </div>
          </div>


          <div className="section-body mt-3">
            <div className="container-fluid">
              <div className="row clearfix">
                <div className="col-md-12">
                  <div className="card">
                    {/* <div className="card-header">
<h3 className="card-title">My Shift</h3>
</div> */}
                    <div className="card-body">
                      <form onSubmit={handleSubmit} >

                        <div class="row">

                          <div className="col-md-3 col-sm-6">
                            <div className="form-group">
                              <input type="date" className="form-control" name="start_date" value={user.start_date}
                                onChange={handelInput} placeholder="Start Date" />

                            </div>
                          </div>

                          <div className="col-md-3 col-sm-6">
                            <div className="form-group">
                              <input type="date" className="form-control" name="end_date" value={user.end_date}
                                onChange={handelInput} placeholder="End Date" />

                            </div>
                          </div>

                          {/* <div className="col-md-3 col-sm-12">
<div className="form-group">

<select className="form-control show-tick"
value={user.employeedet} name="employeedet"
onChange={handelInput}

>
<option value="ALL">All Employees</option>
{data.map((option) => (
<option key={option.user_id} value={option.user_id}>
{option.first_name} {option.last_name} ({option.employee_id})
</option>
))}
</select>
</div>
</div> */}



                          <div className="col-md-3 col-sm-6">

                            <Select
                              options={options}
                              isSearchable={true}
                              placeholder="Select Employee"
                              value={options.find(opt => opt.value === user.employeedet) || null}
                              onChange={(selected) =>
                                setUser((prev) => ({
                                  ...prev,
                                  employeedet: selected?.value || "ALL",
                                }))
                              }
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "28px",
                                  height: "28px",
                                  borderRadius: "4px",
                                  borderColor: "#ced4da",
                                  boxShadow: "none",
                                  fontSize: "12px",
                                  padding: "0 4px",
                                  "&:hover": { borderColor: "#b3b3b3" }
                                }),

                                valueContainer: (base) => ({
                                  ...base,
                                  height: "28px",
                                  padding: "0 6px",
                                }),

                                input: (base) => ({
                                  ...base,
                                  margin: "0px",
                                  padding: "0px"
                                }),

                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "28px"
                                }),

                                menu: (base) => ({
                                  ...base,
                                  borderRadius: "4px",
                                  zIndex: 9999
                                }),

                                option: (base, state) => ({
                                  ...base,
                                  fontSize: "12px",
                                  padding: "6px 10px",
                                  backgroundColor: state.isFocused ? "#f8f9fa" : "white",
                                  color: "#333"
                                })
                              }}


                              classNamePrefix="react-select"
                            />


                            {/* <select className="form-control show-tick" name="user_id"  isSearchable={true} onChange={handelInput} // Enable search
value={user.user_id}>
<option value="ALL">All Employee</option>
{dataval.map(option => (
<option key={option.user_id} value={option.user_id}>
{option.first_name} {option.last_name} {option.employee_id}
</option>
))}
</select> */}
                          </div>


                          <div className="col-md-3 col-sm-6">
                            <div className="form-group">

                              <button type="submit" className="btn btn-primary">
                                GET
                              </button>


                            </div>
                          </div>

                        </div>












                      </form>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div className="section-body">
            <div className="container-fluid">
              <div className="tab-content">
                <div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
                  <div className="card">

                    <div className="card-header">
                      <h3 className="card-title" style={{ color: '#e96827' }}>Shift List</h3>
                      <div
                        className="card-options"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <EntriesSelector
                          entriesPerPage={entriesPerPage}
                          setEntriesPerPage={setEntriesPerPage}
                          setCurrentPage={setCurrentPage}
                        />

                        {/* 🔽 SEARCH BOX WRAPPER */}
                        <div style={{ position: "relative", width: "200px" }}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                              setCurrentPage(1);
                            }}
                            style={{
                              width: "100%",
                              height: "30px",
                              fontSize: "13px",
                              borderRadius: "4px",
                              paddingRight: "28px", // ✅ space for X
                            }}
                          />

                          {searchTerm.length > 0 && (
                            <span
                              onClick={clearInput}
                              style={{
                                position: "absolute",
                                right: "8px",        // ✅ INSIDE input
                                top: "50%",          // ✅ vertically centered
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#aaa",
                                fontSize: "16px",
                                userSelect: "none",
                              }}
                            >
                              ✖
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* <div>
<DataTable 
columns={column} 
data={data}
customStyles={customStyles}
pagination 
highlightOnHover
responsive
paginationPerPage={10}
paginationRowsPerPageOptions={[25,50,100,500]}
className="table table-striped table-bordered"> 
</DataTable>
</div> */}







                    {/* Loading Spinner */}
                    {loading && (
                      <div className="card-body">
                        <div class="d-flex justify-content-center">
                          <div class="spinner"></div>
                        </div>
                      </div>
                    )}

                    {!loading && (
                      <div className="card-body">

                        <div className="table-responsive">




                          <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                            <thead>
                              <tr>

                                {columns.map((col) => (
                                  <th
                                    key={col.key}
                                    onClick={col.sortable ? () => handleSort(col.key) : null}
                                    style={{ cursor: col.sortable ? "pointer" : "default" }}
                                  >
                                    {col.label}
                                    {col.sortable && (
                                      sortConfig.key === col.key
                                        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
                                        : " ⇅"   // <-- DEFAULT SORT ICON
                                    )}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {filteredData.length > 0 ? (
                                filteredData.map((record) => (



                                  <tr key={record.employee_id}>

                                    <td>{record.emp_id}</td>

                                    
           <td>
  <div className="employee-photo">

    <img
      src={`${MOBILE_API_BASE_URL}/${record.image}`}
      className="emp-thumb"
      alt="employee"
    />

    <div className="emp-preview">
      <img
        src={`${MOBILE_API_BASE_URL}/${record.image}`}
        alt="preview"
      />
    </div>

  </div>
</td>
                                    <td>{record.emp_name}</td>
                                    <td>{record.department_name}</td>
                                    <td>{record.address}</td>
                                    <td>{record.log_date}</td>
                                    <td>{record.log_date_time}</td>
                                    <td>{record.punch_direction}</td>

                                  </tr>

                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7" style={{ color: 'red', textAlign: 'center', fontWeight: "bold" }}>No records found</td>
                                </tr>
                              )}


                            </tbody>
                          </table>
                        </div>

                        <Pagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />


                      </div>
                    )
                    }
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </div>







    </>
  );

}



const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
  statisticsOpen: state.settings.isStatistics,
  statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
  statisticsAction: (e) => dispatch(statisticsAction(e)),
  statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(AttendanceLogList);